import * as React from 'react';
import Constants from 'src/_constants/Constants';
import { documentService } from '@services/DocumentService';

var rootPath = documentService.getRootPath();

export const Help = () => (
  <>
    <div className="row middle-xs mb-10 pb-10">
      <h2>Profiles </h2>
      <a
        href={rootPath + '/download?filename=' + encodeURIComponent(Constants.helpDocs.PROFILE)}
        target="_blank"
        download={Constants.helpDocs.PROFILE}
      >
        <i className="far fa-fw fa-2x fa-file-pdf" />
      </a>
      <div className="col-xs-12">
        <div className="row">
          <div className="col-md-2">
            <p>Customer, Escrow, Property Management, Real Estate, Transaction Coordinator</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row middle-xs mb-10 pb-10">
      <h2>Quotes & Contracts </h2>
      <a
        href={rootPath + '/download?filename=' + encodeURIComponent(Constants.helpDocs.QUOTES_CONTRACTS)}
        target="_blank"
      >
        <i className="far fa-fw fa-2x fa-file-pdf" />
      </a>
      <div className="col-xs-12">
        <div className="row">
          <div className="col-md-2">
            <p>Quotes, Create New Contract</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row middle-xs mb-10 pb-10">
      <h2>Contract Actions </h2>
      <a
        href={rootPath + '/download?filename=' + encodeURIComponent(Constants.helpDocs.CONTRACT_ACTIONS)}
        target="_blank"
      >
        <i className="far fa-fw fa-2x fa-file-pdf" />
      </a>
      <div className="col-xs-12">
        <div className="row">
          <div className="col-md-2">
            <p>My Action Items, Comments, Quick Close, Resell, Resend, Cancel, Terminate</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row middle-xs mb-10 pb-10">
      <h2>Renewal </h2>
      <a href={rootPath + '/download?filename=' + encodeURIComponent(Constants.helpDocs.RENEWAL)} target="_blank">
        <i className="far fa-fw fa-2x fa-file-pdf" />
      </a>
      <div className="col-xs-12">
        <div className="row">
          <div className="col-md-3">
            <p>Renew, Send Renewal Notice</p>
          </div>
        </div>
      </div>
    </div>
  </>
);



// WEBPACK FOOTER //
// ./src/help/help.component.tsx